export const utilityType = {
  search: "検索",
  user: "ユーザー",
  reservation: "予約情報",
  template: "テンプレ",
  notification: "通知",
};
